var _excluded = ["children", "as", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { combineRules } from 'fela';
export default function FelaComponentFactory(createElement, RendererContext, FelaTheme) {
  function FelaComponent(_ref) {
    var children = _ref.children,
        _ref$as = _ref.as,
        as = _ref$as === void 0 ? 'div' : _ref$as,
        style = _ref.style,
        otherProps = _objectWithoutProperties(_ref, _excluded);

    var renderFn = function renderFn(renderer) {
      if (renderer.devMode && style == null) {
        // eslint-disable-next-line no-console
        console.warn('"FelaComponent" is being rendered without a style prop\nIf all you need is access to theme, try using "FelaTheme" or the "useFela" hook instead');
      }

      return createElement(FelaTheme, undefined, function (theme) {
        // TODO: could optimize perf by not calling combineRules if not necessary
        var renderedRule = renderer.renderRule(combineRules(style), _objectSpread(_objectSpread({}, otherProps), {}, {
          theme: theme
        }));

        if (children instanceof Function) {
          return children({
            className: !renderer.isNativeRenderer && renderedRule,
            style: renderer.isNativeRenderer && renderedRule,
            theme: theme,
            as: as
          });
        }

        return createElement(as, {
          className: !renderer.isNativeRenderer && renderedRule,
          style: renderer.isNativeRenderer && renderedRule
        }, children);
      });
    };

    return createElement(RendererContext.Consumer, undefined, renderFn);
  }

  return FelaComponent;
}